import { makeReactRuntime } from '@viziertronic/react-runtime'

import { BrowserLayer } from '#di/browser/browser.layer.ts'
import { appMemoMap } from '#runtime/shared.memo-map.ts'

const ReactBrowserRuntime = makeReactRuntime(() => BrowserLayer, {
  memoMap: appMemoMap,
})
export const ReactBrowserRuntimeProvider = ReactBrowserRuntime.Provider

export function useBrowserRuntime() {
  return ReactBrowserRuntime.use()
}
